type RecurrenceRate = 'weekly' | 'bi-weekly' | 'monthly';

export const parseRecurrenceRate = (apiRecurrenceRate?: string | null): RecurrenceRate => {
  switch (apiRecurrenceRate) {
    case 'bi-weekly':
    case 'monthly': {
      return apiRecurrenceRate;
    }
    default: {
      return 'weekly';
    }
  }
};
